module.exports = __webpack_public_path__ + "static/media/message.7f619d8e.svg";